// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Details-specific styles (extends RightSidebar) */
.chatview-details-header {
  min-height: 72px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
}

.chatview-details-header.clickable {
  cursor: pointer;
}

.chatview-details-avatars {
  position: relative;
  width: 42px;
  height: 42px;
  margin-right: 12px;
  flex-shrink: 0;
}

.chatview-details-avatar-single {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.chatview-details-avatar-first {
  position: absolute;
  width: 30.24px;
  height: 30.24px;
  margin: 0px;
  top: -0.84px;
  left: -0.84px;
  border-radius: 50%;
  border: 2px solid white;
  object-fit: cover;
}

.chatview-details-avatar-second {
  position: absolute;
  width: 30.24px;
  height: 30.24px;
  margin: 0px;
  top: 12.6px;
  left: 12.6px;
  border-radius: 50%;
  border: 2px solid white;
  object-fit: cover;
}

.chatview-details-avatar-fallback {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.chatview-details-title-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  overflow: hidden;
  font-family: Roboto, sans-serif;
}

.chatview-details-title {
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  color: rgb(0, 0, 0);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.chatview-details-topic {
  font-size: 18px;
  line-height: 22px;
  font-weight: 500;
  color: rgb(0, 0, 0);
  overflow-wrap: break-word;
  word-break: break-word;
  margin-bottom: 4px;
  display: block;
  margin-bottom: 4px;
  margin-top: 4px;

}

.chatview-details-id {
  font-size: 12px;
  color: rgb(151, 151, 151);
  line-height: 16px;
}

.chatview-details-edit-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  color: #666;
  font-size: 20px;
}

.chatview-details-edit-icon:hover {
  color: #333;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
}

.chatview-details-block {
  font-family: Roboto, Arial, sans-serif;
}

.chatview-details-block-header {
  box-sizing: border-box;
  padding: 16px;
  font-size: 14px;
  color: rgb(151, 151, 151);
  border-top: 1px solid rgb(220, 220, 220);
  cursor: pointer;
}

.chatview-details-block-header.no-top-border {
  border-top: none;
}

.chatview-details-block-item {
  cursor: pointer;
  min-height: 56px;
  display: flex;
  position: relative;
  padding-left: 16px;
}

.chatview-details-block-item-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  position: absolute;
  top: 16px;
  left: 16px;
  color: #474747;
}

.chatview-details-block-item-icon ion-icon {
  height: 24px;
  width: 24px;
}

.chatview-details-block-item-icon svg {
  width: 24px;
  height: 24px;
}

.chatview-details-block-item-icon i {
  font-size: 18px;
}

.chatview-details-block-item-text {
  font-size: 14px;
  line-height: 16px;
  overflow-wrap: break-word;
  word-break: break-word;
  color: rgb(0, 0, 0);
  align-items: center;
  position: absolute;
  top: 20px;
  left: 60px;
}

.chatview-details-participant-count {
  font-weight: 500;
  color: var(--netsfere-red);
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Details.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,OAAO;EACP,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":["/* Details-specific styles (extends RightSidebar) */\n.chatview-details-header {\n  min-height: 72px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  box-sizing: border-box;\n}\n\n.chatview-details-header.clickable {\n  cursor: pointer;\n}\n\n.chatview-details-avatars {\n  position: relative;\n  width: 42px;\n  height: 42px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.chatview-details-avatar-single {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.chatview-details-avatar-first {\n  position: absolute;\n  width: 30.24px;\n  height: 30.24px;\n  margin: 0px;\n  top: -0.84px;\n  left: -0.84px;\n  border-radius: 50%;\n  border: 2px solid white;\n  object-fit: cover;\n}\n\n.chatview-details-avatar-second {\n  position: absolute;\n  width: 30.24px;\n  height: 30.24px;\n  margin: 0px;\n  top: 12.6px;\n  left: 12.6px;\n  border-radius: 50%;\n  border: 2px solid white;\n  object-fit: cover;\n}\n\n.chatview-details-avatar-fallback {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background-color: #333;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.chatview-details-title-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1;\n  overflow: hidden;\n  font-family: Roboto, sans-serif;\n}\n\n.chatview-details-title {\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 500;\n  color: rgb(0, 0, 0);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-bottom: 4px;\n}\n\n.chatview-details-topic {\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 500;\n  color: rgb(0, 0, 0);\n  overflow-wrap: break-word;\n  word-break: break-word;\n  margin-bottom: 4px;\n  display: block;\n  margin-bottom: 4px;\n  margin-top: 4px;\n\n}\n\n.chatview-details-id {\n  font-size: 12px;\n  color: rgb(151, 151, 151);\n  line-height: 16px;\n}\n\n.chatview-details-edit-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  cursor: pointer;\n  color: #666;\n  font-size: 20px;\n}\n\n.chatview-details-edit-icon:hover {\n  color: #333;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 50%;\n}\n\n.chatview-details-block {\n  font-family: Roboto, Arial, sans-serif;\n}\n\n.chatview-details-block-header {\n  box-sizing: border-box;\n  padding: 16px;\n  font-size: 14px;\n  color: rgb(151, 151, 151);\n  border-top: 1px solid rgb(220, 220, 220);\n  cursor: pointer;\n}\n\n.chatview-details-block-header.no-top-border {\n  border-top: none;\n}\n\n.chatview-details-block-item {\n  cursor: pointer;\n  min-height: 56px;\n  display: flex;\n  position: relative;\n  padding-left: 16px;\n}\n\n.chatview-details-block-item-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  color: #474747;\n}\n\n.chatview-details-block-item-icon ion-icon {\n  height: 24px;\n  width: 24px;\n}\n\n.chatview-details-block-item-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.chatview-details-block-item-icon i {\n  font-size: 18px;\n}\n\n.chatview-details-block-item-text {\n  font-size: 14px;\n  line-height: 16px;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  color: rgb(0, 0, 0);\n  align-items: center;\n  position: absolute;\n  top: 20px;\n  left: 60px;\n}\n\n.chatview-details-participant-count {\n  font-weight: 500;\n  color: var(--netsfere-red);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
